module.exports = __webpack_public_path__ + "static/img/PC-2.dfd6254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/PC-2.png
// module id = 3wZw
// module chunks = 0